"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWidgetName = exports.Wrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../../utils/theme");
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"], ["\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_a) {
    var iconType = _a.iconType;
    return !iconType && "margin-top:16px;";
});
exports.StyledWidgetName = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.8px;\n  margin-top: 8px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.8px;\n  margin-top: 8px;\n  text-transform: uppercase;\n"])), theme_1.colors.grey5);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map